import React from 'react';
import './Video.scss';

const Video = ({ onClicked }) => {
  const getSrc = (fileName) => require(`../../assets/imgs/video/${fileName}.svg`);

  return (
    <div className="video-wrapper">
      <div className="video-thumb one" />
      <div className="video-thumb two" />
      <div className="video-link" onClick={() => onClicked && onClicked()}>
        <div className="video">
          <img src={getSrc('play')} alt="" />
        </div>
        <div className="progress-bar" />
        <div className="menu">
          <div>
            <img src={getSrc('play')} alt="" />
            <img src={getSrc('volume')} alt="" />
            <span>00:02 / 04:26</span>
          </div>
          <div>
            <img src={getSrc('expand')} alt="" />
            <img src={getSrc('cog')} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Video;
